import { TEhrConnectionItem, TPfSetupStatus } from 'types/ehrConnection';
import { EHR_CONFIG_MAP } from './ehrConfig';

// Practice Fusion 异步开通进度的短标签（完整说明用后端的 setupMessage）
export const PF_SETUP_LABEL: Record<TPfSetupStatus, string> = {
    waiting_for_practice: 'Waiting for invite',
    access_code_needed: 'Access code needed',
    access_code_rejected: 'Access code rejected',
    setting_up: 'Setting up',
    needs_support: 'Needs support',
    connected: 'Connected',
};

// PF 还没开通完：连接行照常列出（带进度标签），不能当「从未连接」或「连接失效」
export const isPfSettingUp = (c: TEhrConnectionItem) => !!c.setupStatus && c.setupStatus !== 'connected';

// PF 还能（重新）交 PAC：PF 那边还没看到 agent / 缺 PAC / PAC 被拒（PAC 每周变）。同 AskChart askForCode
export const pfNeedsNewCode = (c: TEhrConnectionItem) =>
    c.setupStatus === 'waiting_for_practice' ||
    c.setupStatus === 'access_code_needed' ||
    c.setupStatus === 'access_code_rejected';

// 有连接记录但不能用（非 custom、非 PF 开通中）：从没连上过 = 验证没过就离开了；连上过 = 后来断了。
// 两者在原型里是不同状态（Agent not added vs Connection lost），不能都当 Connection lost
export const neverConnected = (c: TEhrConnectionItem) =>
    c.connectionStatus !== 'connected' && !c.isCustom && !isPfSettingUp(c) && !c.hasSuccessConnected;
export const connectionLost = (c: TEhrConnectionItem) =>
    c.connectionStatus !== 'connected' && !c.isCustom && !isPfSettingUp(c) && !!c.hasSuccessConnected;

// 从没连上过的文案按连接方式给（原型只有 agent 邀请型的「Agent not added」）：
// agent_auto / agent_password 要在 EHR 里把 agent 邮箱加成用户；account_password 用诊所自己的登录连；其它兜底
export const notConnectedCopy = (name: string): { tag: string; sub: string } => {
    const type = EHR_CONFIG_MAP[name]?.verifyType;
    if (type === 'agent_auto' || type === 'agent_password') {
        return { tag: 'Agent not added', sub: `Add the agent email as a user in ${name} so Klarity can connect.` };
    }
    if (type === 'account_password') {
        return { tag: 'Not connected', sub: `Sign in with your ${name} login so Klarity can connect.` };
    }
    return { tag: 'Not connected', sub: `Finish connecting ${name} so Klarity can start billing.` };
};

// 原型 V3 Reconnect：要交凭证的 EHR（密码 / 登录名+密码 / PF 的 PAC）重连 = 直接回 step 2 重新输入；
// 邀请型一键重新验证
const CREDENTIAL_VERIFY_TYPES = new Set(['agent_password', 'account_password', 'pf_access_code']);
export const reconnectsWithCredentials = (ehrName: string) =>
    CREDENTIAL_VERIFY_TYPES.has(EHR_CONFIG_MAP[ehrName]?.verifyType || '');
